/**
 * Coarse ordering of validation phases. Rules run in ascending phase order; within a phase,
 * registration order is preserved (so pattern linting precedes architecture linting).
 */
export var ValidationPhase;
(function (ValidationPhase) {
    /** Spectral linting over the raw JSON document(s). */
    ValidationPhase[ValidationPhase["LINT"] = 0] = "LINT";
    /** JSON-Schema (AJV) structural validation. */
    ValidationPhase[ValidationPhase["STRUCTURAL"] = 1] = "STRUCTURAL";
    /** Semantic checks over the parsed CALM model (e.g. controls). */
    ValidationPhase[ValidationPhase["SEMANTIC"] = 2] = "SEMANTIC";
    /** Recursive validation of referenced sub-architectures. */
    ValidationPhase[ValidationPhase["RECURSIVE"] = 3] = "RECURSIVE";
})(ValidationPhase || (ValidationPhase = {}));
export function emptyRuleResult() {
    return { jsonSchemaOutputs: [], spectralOutputs: [], hasErrors: false, hasWarnings: false };
}
//# sourceMappingURL=validation-rule.js.map